import React from 'react';

const TeamSync = () => {
    return (
        <div className="self-stretch px-8 py-16 bg-neutral-900 flex flex-col justify-center items-center gap-12">
            <div className="max-w-7xl mx-auto w-full">
                <div className="text-center mb-12">
                    <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
                        Real-World Agency: Coordination With Your Team
                    </h2>
                    <p className="!text-stone-300 text-lg font-medium font-['Inter'] max-w-4xl mx-auto">
                        Unlike standard bots limited to databases and backend integrations, we bridge the gap between digital systems and your physical floor staff. Once onboarded, it proactively queries your team across your internal channels to get real-time answers for callers.
                    </p>
                </div>

                <div className="max-w-3xl mx-auto bg-gradient-to-br from-neutral-800 to-neutral-900 rounded-lg p-8 border border-neutral-700">
                    <div className="flex flex-col gap-6">
                        <div className="flex gap-4 items-start">
                            <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                                <i className="fa fa-user text-white text-sm"></i>
                            </div>
                            <div className="flex-1">
                                <div className="bg-blue-600 text-white rounded-lg p-4 inline-block">
                                    <p className="text-sm font-medium">"Is my car ready for pickup yet?"</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-4 items-start">
                            <div className="flex-shrink-0 w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center">
                                <i className="fa fa-robot text-white text-sm"></i>
                            </div>
                            <div className="flex-1">
                                <div className="bg-neutral-700 text-stone-300 rounded-lg p-4 inline-block">
                                    <p className="text-sm font-medium">"One moment, let me check with the service team for you..."</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-center py-2">
                            <div className="bg-neutral-700 border border-neutral-600 rounded-full px-6 py-2 flex items-center gap-2">
                                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                <span className="text-stone-400 text-xs font-medium">Querying Staff...</span>
                            </div>
                        </div>

                        <div className="flex gap-4 items-start justify-end">
                            <div className="flex-1 text-right">
                                <div className="bg-green-600 text-white rounded-lg p-4 inline-block">
                                    <p className="text-sm font-medium">"Yes, just finished!"</p>
                                </div>
                            </div>
                            <div className="flex-shrink-0 w-10 h-10 bg-green-600 rounded-full flex items-center justify-center">
                                <i className="fa fa-wrench text-white text-sm"></i>
                            </div>
                        </div>

                        <div className="flex gap-4 items-start">
                            <div className="flex-shrink-0 w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center">
                                <i className="fa fa-robot text-white text-sm"></i>
                            </div>
                            <div className="flex-1">
                                <div className="bg-neutral-700 text-stone-300 rounded-lg p-4 inline-block">
                                    <p className="text-sm font-medium">"Great news! The team just finished. It's ready for you now."</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-8">
                    <p className="!text-stone-400 text-sm font-medium font-['Inter'] italic">
                        "It's like adding a remote employee to the team without the overhead."
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TeamSync;
